import { render, staticRenderFns } from "./tabApprovalMatters.vue?vue&type=template&id=d2a0ebde&"
import script from "./tabApprovalMatters.vue?vue&type=script&lang=js&"
export * from "./tabApprovalMatters.vue?vue&type=script&lang=js&"
import style0 from "./tabApprovalMatters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2a0ebde')) {
      api.createRecord('d2a0ebde', component.options)
    } else {
      api.reload('d2a0ebde', component.options)
    }
    module.hot.accept("./tabApprovalMatters.vue?vue&type=template&id=d2a0ebde&", function () {
      api.rerender('d2a0ebde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/PreWarning/components/tabApprovalMatters.vue"
export default component.exports